import useSWR from 'swr'
import { fetcher } from '../services/http.service'
import { GetDeliveryInfoResponse } from './apiTypes'
import { queries } from "./queries";

export function useDeliveryInfo(tracking_number?: string) {
  const { data, error, isLoading, mutate } = useSWR<GetDeliveryInfoResponse>(
    tracking_number ? queries.shipping.deliveryinfo(tracking_number) : null,
    fetcher,
    { revalidateIfStale: true, revalidateOnFocus: true, revalidateOnReconnect: true, dedupingInterval: 0 }
  )

  return {
    mutate,
    deliveryInfo: data,
    isLoading,
    isError: error,
  }
}
